export const NEWS_LIST = "NEWS_LIST";
export const NEWS_LIST_FAILED = "NEWS_LIST_FAILED";
export const NEWS_LIST_SUCCESS = "NEWS_LIST_SUCCESS";

export const BLOG_LIST = "BLOG_LIST";
export const BLOG_LIST_FAILED = "BLOG_LIST_FAILED";
export const BLOG_LIST_SUCCESS = "BLOG_LIST_SUCCESS";
